import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.ImpactAggregations.meta.exhausted) return;
    if (getState().AnalyticsDashboard.ImpactAggregations.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_IMPACT_AGGREGATIONS_REQUEST,
    });

    $.when(Ajax.ImpactAggregationsService())
      .done(function (response) {
        dispatch({
          type: TYPES.FETCH_IMPACT_AGGREGATIONS_SUCCESS,
          aggregations: response,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_IMPACT_AGGREGATIONS_FAILURE,
        });
      });
  };
};

const ImpactAggregations = {
  fetch: fetch,
};
export { ImpactAggregations };

const initialState = {
  aggregations: {
    counts: {},
    collections: {},
    startsOn: null,
    finishesOn: null,
  },
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_IMPACT_AGGREGATIONS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_IMPACT_AGGREGATIONS_SUCCESS:
      return Object.assign({}, state, {
        aggregations: Object.assign({}, state.aggregations, {
          counts: action.aggregations.counts,
          collections: action.aggregations.collections,
          startsOn: action.aggregations.starts_on,
          finishesOn: action.aggregations.finishes_on,
        }),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_IMPACT_AGGREGATIONS_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    default:
      return state;
  }
};

export { reducer, reducer as default };
